import styled from 'styled-components';

/** The restaurant's phone under the location: tap to call on a phone. */
export const PhoneLink = styled.a`
  color: ${({ theme }) => theme.primary};
  font-weight: 600;
  text-decoration: underline;
`;
